import axios from "axios";
// import axiosRetry, { isNetworkOrIdempotentRequestError, exponentialDelay } from 'axios-retry';

const instance = axios.create({
  timeout: 15000,
});

const requestHandler = (request: any) => {
  // Modify request here
  return request;
};

const responseHandler = (response: any) => {
  // Modify response here
  if (response && response.data) {
    return response.data;
  }
  return response;
};

const errorHandler = (error: any) => {
  console.error("errorinadapter ---->", error);
  if (
    (error && error.code && error.code === "ECONNABORTED") ||
    (error && error.message === "Network Error")
  ) {
    error.message =
      "We are unable to connect to server. please try again later.";
  }
  if (error && error.response && error.response.status === 400) {
    error.message = "Something went wrong, please try again.";
  }
  return Promise.reject(error);
};

// request intercepter
instance.interceptors.request.use((request) => requestHandler(request));
// response intercepter
instance.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

export default instance;
